
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
    transform(value: number, decimalPlaces: number = 2): number {
        const factor = Math.pow(10, decimalPlaces);
        return Math.floor(value * factor) / factor;
    }
}